<template>
    <!-- <div class="d-flex align-center justify-center" style="height: 100vh; background-image: url('./assets/jamz_background.jpeg');"> -->
    <div class="d-flex align-center justify-center" style="height: 100vh;">
        <v-sheet width="400" class="mx-auto">
            <v-form fast-fail @submit.prevent="login">
                <h1 class="text-center" style="color:#607d8b">                
                    <span class="font-weight-light">jamz</span>
                    <span class="font-weight-black">care</span>
                </h1>
                <v-text-field 
                    variant="outlined" 
                    v-model="username" 
                    label="User Name"
                    :rules="[rules.logins]"
                    color="jamzcare">
                </v-text-field>
                <v-text-field
                    v-model="password"
                    variant="outlined" 
                    color="jamzcare"
                    :append-inner-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required, rules.min, rules.valid]"
                    :type="show1 ? 'text' : 'password'"
                    name="input-10-2"
                    label="Password"
                    hint="At least 8 characters"
                    class="input-group--focused"
                    @click:append-inner="show1 = !show1"
                ></v-text-field>
                <v-autocomplete
                    v-model="location"
                    label="Location"
                    :items="locationItems"
                    variant="outlined"
                    density="comfortable"
                    color="primary"/>
                <a href="#" class="text-body-2 font-weight-regular">Forgot Password?</a>

                <v-btn type="submit" color="primary" block class="mt-2 rounded-xl">Sign in</v-btn>

            </v-form>
            <div class="mt-2">
                <p class="text-body-2">Don't have an account? <a href="#">Sign Up</a></p>
            </div>
        </v-sheet>
    </div>
</template>
 
<script>
import { defineComponent } from 'vue'
import router from '@/router'
import { store } from './shared/store.js'

export default defineComponent({
    name: 'LoginPage',
    data() {
        return {
            image: 'jamz_backround.jpeg',
            store,
            location: '',
            locationItems: ['Ward 12', 'Clinic A', 'Ward 24'],
            encodedStringAtoB: 'Y2hhcm1lZDEyMw==',
            logins: ['phoebe', 'paige', 'piper', 'prue', 'billie'],
            username: '',
            show1: true,
            password: '',
            rules: {
            required: value => !!value || 'Required.',
            valid: value => !!(value===atob(this.encodedStringAtoB)) || 'Invalid.',
            logins: value => !!(this.logins.includes(value)) || 'Invalid.',
            min: v => v.length >= 8 || 'Min 8 characters',
            emailMatch: () => (`The email and password you entered don't match`),
            },
        };
    },
    methods: {
        getStyle() {
            return require('@/assets/' + this.store.avatar)
        },
        login() {
            if (this.logins.includes(this.username) && this.password===atob(this.encodedStringAtoB)) {
                this.setUserState()
                router.push({ path: '/' })
            }
        },
        capitalized(name) {
            const capitalizedFirst = name[0].toUpperCase();
            const rest = name.slice(1);

            return capitalizedFirst + rest;
        },
        setUserState() {
            this.store.username = this.username.toLowerCase()
            this.store.userTitle = this.capitalized(this.username)
            // this.store.avatar = '@/assets/' + this.username + '.png'
            this.store.avatar = this.username + '.png'
            this.store.email = this.username + "@jamzcare.com"
            this.store.location = this.location
            this.store.role = 'doctor'
            if (this.username.toLowerCase() === 'billie') {
                this.store.role = 'nurse'
            }
        }
    },
})
</script>
